import React, { Component } from 'react';
import {Route} from "react-router-dom";
import Purpose from "./Purpose";
import Scope from "./Scope";
import TermsAndDefinitions from "./TermsAndDefinitions";
import References from "./References";
import InterestedParties from "./InterestedParties";
import {organisationDetails} from "../../util/ApiUtils";
import DocumentControlHeader from "./DocumentControlHeader";
import AcronymsAndAbbreviations from "./AcronymsAndAbbreviations";
import {Spinner} from "../common/Spinner";
import OrgChart from "./OrgChart";
import ExternalInternalIssues from "./ExternalInternalIssues";
import PositionDescriptions from "./PositionDescriptions";
import Policies from "./Policies";
import Objectives from "./Objectives";
import * as CommonUtils from "../../util/CommonUtils";

class ContextOfOrganisation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latestRevision: {},
            isLoading: true,
        };
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    latestRevision: response.latestRevisionDto,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        let { state } = this;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        if (state.isLoading) {
            return <Spinner/>;
        }
        return <div>
            <div className="mui-container-fluid">
                <DocumentControlHeader currentUser={this.props.currentUser} revision={state.latestRevision} organisation={state.organisation} isReadOnly={isDemo || isAuditor || isViewer}>
                    <Route
                        path={`/context-of-organisation/purpose`}
                        render={() =>
                            <Purpose currentUser={this.props.currentUser} revision={state.latestRevision}/>
                        }
                    />
                    <Route path={`/context-of-organisation/scope`}
                           render={() =>
                               <Scope currentUser={this.props.currentUser} revision={state.latestRevision}/>
                           }
                    />
                    <Route path={`/context-of-organisation/objectives`}
                           render={() =>
                               <Objectives currentUser={this.props.currentUser} revision={state.latestRevision}/>
                           }
                    />
                    <Route path={`/context-of-organisation/policies`}
                           render={() =>
                               <Policies currentUser={this.props.currentUser} revision={state.latestRevision}/>
                           }
                    />
                    <Route path={`/context-of-organisation/orgChart`}
                           render={() =>
                               <OrgChart currentUser={this.props.currentUser}/>
                           }
                    />
                    <Route path={`/context-of-organisation/position-descriptions`}
                           render={() =>
                               <PositionDescriptions currentUser={this.props.currentUser}/>
                           }
                    />
                    <Route path={`/context-of-organisation/terms-and-definitions`}
                           render={() =>
                               <TermsAndDefinitions currentUser={this.props.currentUser}/>
                           }
                    />
                    <Route path={`/context-of-organisation/acronyms-and-abbreviations`}
                           render={() =>
                               <AcronymsAndAbbreviations currentUser={this.props.currentUser}/>
                           }
                           />
                    <Route path={`/context-of-organisation/references`}
                           render={() =>
                               <References currentUser={this.props.currentUser}/>
                           }
                           />
                    <Route path={`/context-of-organisation/interested-parties`}
                           render={() =>
                               <InterestedParties currentUser={this.props.currentUser}/>
                           }/>
                    <Route path={`/context-of-organisation/external-internal-issues`}
                           render={() =>
                               <ExternalInternalIssues currentUser={this.props.currentUser}/>
                           }/>
                </DocumentControlHeader>
            </div>
        </div>;
    }
}

export default ContextOfOrganisation;